var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "1480 569 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1168"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486 569h15a6 6 0 0 1 6 6v15a6 6 0 0 1-6 6h-15a6 6 0 0 1-6-6v-15a6 6 0 0 1 6-6z",
    fillRule: "evenodd",
    "data-name": "Rectangle 935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1499.53 587.606-2.214-2.207a5.157 5.157 0 0 0 1.1-3.19 5.209 5.209 0 1 0-5.208 5.208 5.158 5.158 0 0 0 3.19-1.1l2.208 2.214a.651.651 0 0 0 .924 0 .652.652 0 0 0 0-.925Zm-10.229-5.397a3.907 3.907 0 1 1 7.815 0 3.907 3.907 0 0 1-7.815 0Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "noun-search-4796617"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7f9542d89c99feb474a12a0df0716b22.svg";
export { ForwardRef as ReactComponent };